import React from 'react';
import './ArticleTeaser.styl';
import Icon from '~/core/scripts/components/Icon';

export default ({ background, url, description, title, name }) => {
  const style = {
    backgroundImage: `url(${background})`
  };

  const href = `${ARTICLE_CONFIG.baseUrl}/${url}`;

  return (
    <a className="teaser-wrapper" href={href} style={style}>
      <div className="teaser-gradient"></div>
      <div className="teaser-text clearfix">
          <div className="teaser-description">
              <div className="teaser-desc">{description}</div>
              <div className="teaser-title">{title}</div>
              <button className="btn btn-teaser accent1"><Icon type="interaktiv"/><strong>Alle Ergebnisse</strong> auf der {name}</button>
          </div>
      </div>
    </a>
  );
};
